const CompanyMutations = {};

export default CompanyMutations;
